import React from "react";
import {
  MultiColumnTable,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import usePaymentDetail from "./usePaymentDetail";
import OverviewShimmer from "../../../Global/Shimmers/OverviewShimmer";

const PaymentDetail = () => {
  const { paymentValues, transactions, transactionFields, isFetching } =
    usePaymentDetail();

  const getRow = (field, data) => {
    return <p className="pro-mb-0">{data[field] ?? "---"}</p>;
  };

  return (
    <div>
      {isFetching ? (
        <div className="pro-p-4 pro-w-100">
          <OverviewShimmer />
        </div>
      ) : (
        <div className="pro-py-5">
          <MultiColumnTable
            minWidth={`30%`}
            title={"Payment Details"}
            data={paymentValues}
          />

          {transactions.length > 0 && (
            <div className="pro-pt-4">
              <h6 className="pro-ttl h6 pro-mb-4 pro-fw-bold">
                Transactions
              </h6>
              <Table
                data={transactions}
                uniqueID={"transaction_id"}
                showCheckBox={false}
                deletable={false}
                assignable={false}
                multiSelect={false}
                fields={transactionFields}
                getRow={getRow}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PaymentDetail;
